export default __webpack_public_path__ + "static/media/about-photo-without-bg.c93cd4fb.png";